export const SEND_EMAIL = "nate.paulemon@auxiliaryone.io";

export const GTM_EMAIL_EVENT = "u_3HCO29_IIZEJu3x6MD";
export const GTM_PHONE_CALL_EVENT = "X_YSCOi-_IIZEJu3x6MD";
